import React from 'react';
import { Lightbulb } from 'lucide-react';

export const QuickActionsTips = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
      {/* Tip 1: Pin your favorite tools */}
      <div className="bg-blue-50 border border-blue-200 rounded-xl p-4">
        <div className="flex items-start gap-3">
          <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
            <Lightbulb className="w-4 h-4 text-blue-600" />
          </div>
          <div>
            <h4 className="font-medium text-blue-900 text-sm">Pin Your Favorite Tools</h4>
            <p className="text-sm text-blue-700 mt-1">
              Hover over any tool card and click the pin icon to keep your favorite tools at the top of your dashboard for quick access.
            </p>
          </div>
        </div>
      </div>

      {/* Tip 2: Customize Your Dashboard */}
      <div className="bg-amber-50 border border-amber-200 rounded-xl p-4">
        <div className="flex items-start gap-3">
          <div className="w-8 h-8 bg-amber-100 rounded-lg flex items-center justify-center flex-shrink-0">
            <Lightbulb className="w-4 h-4 text-amber-600" />
          </div>
          <div>
            <h4 className="font-medium text-amber-900 text-sm">Customize Your Dashboard</h4>
            <p className="text-sm text-amber-700 mt-1">
              Hover over any tool card and click the hide icon to remove tools you don&apos;t need. To restore hidden tools, click the &quot;Dashboard Tools Settings&quot; button or use &quot;Show Hidden Tools&quot; when available.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
